import type {SVGProps} from "react";

export const TotalExchangedIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}
    >
        <path
            d="M5.56576 2.13123L2.85742 4.83956L5.56576 7.54789"
            stroke="#00C49A"
            strokeWidth="1.35"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.85742 4.8396H13.6908"
            stroke="#00C49A"
            strokeWidth="1.35"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.9824 14.3188L13.6908 11.6104L10.9824 8.9021"
            stroke="#00C49A"
            strokeWidth="1.35"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.6908 11.6104H2.85742"
            stroke="#00C49A"
            strokeWidth="1.35"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
